import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  Grid,
  CircularProgress,
  FormControlLabel,
  Switch,
  Checkbox,
  withStyles,
  Typography,
  Tooltip,
  IconButton,
} from '@material-ui/core'
import { Info } from '@material-ui/icons'
import { getCustomAttributes } from 'actions/contacts'
import {
  handleFormFieldChange,
  formFieldRequiredChange,
} from 'actions/signupForm/addOrEdit'
import styles from './styles'
import { startCase } from 'lodash'
import language from 'utils/vast-languagepack'

const Field = connect(
  (state, { name }) => ({
    checked: Boolean(state.signupForm.addOrEdit.fields[name]),
    required: state.signupForm.addOrEdit.fields[name]
      ? state.signupForm.addOrEdit.fields[name].required
      : false,
  }),
  (dispatch) =>
    bindActionCreators(
      { handleFormFieldChange, formFieldRequiredChange },
      dispatch,
    ),
)(
  withStyles(styles)(
    ({
      name,
      checked,
      required,
      handleFormFieldChange,
      formFieldRequiredChange,
      classes,
      icon,
    }) => {
      return (
        <Grid justify="space-between" container spacing={24}>
          <Grid item>
            <FormControlLabel
              control={
                <Switch
                  checked={checked}
                  onChange={() => handleFormFieldChange(name)}
                />
              }
              label={
                icon ? (
                  <span>
                    <span>{startCase(name)}</span>
                    <span>
                      <Tooltip
                        title={language.signupform.add.toolTips.requiredFields}
                      >
                        <IconButton className={classes.headingIcon}>
                          <Info />
                        </IconButton>
                      </Tooltip>
                    </span>
                  </span>
                ) : (
                  startCase(name)
                )
              }
              classes={{ label: classes.fieldSwitchLabel }}
            />
          </Grid>
          <Grid item>
            <Checkbox
              checked={required}
              onChange={() => formFieldRequiredChange(name)}
              disabled={!checked}
            />
          </Grid>
        </Grid>
      )
    },
  ),
)

export default connect(
  (state) => ({
    customAttributesLoadStatus: state.loadStatus.customAttributes,
    customAttributes: state.contacts.customAttributes,
  }),
  (dispatch) => bindActionCreators({ getCustomAttributes }, dispatch),
)(({ customAttributesLoadStatus, customAttributes, getCustomAttributes }) => {
  if (!customAttributesLoadStatus) {
    getCustomAttributes()
  }

  return (
    <>
      <Grid item xs={12}>
        <Grid justify="space-between" container spacing={24}>
          <Grid item>
            <Typography variant="caption">
              {language.signupform.add.labels.availableFields}
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="caption">
              {language.signupform.add.labels.required}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Field name="email" icon />
      </Grid>
      <Grid item xs={12}>
        <Field name="phone" icon />
      </Grid>
      <Grid item xs={12}>
        <Field name="first_name" />
      </Grid>
      <Grid item xs={12}>
        <Field name="middle_name" />
      </Grid>
      <Grid item xs={12}>
        <Field name="last_name" />
      </Grid>
      <Grid item xs={12}>
        <Field name="location" />
      </Grid>
      {customAttributesLoadStatus ? (
        Object.values(customAttributes).map((customAttribute) => (
          <Grid key={`${customAttribute.name}FieldGridItem`} item xs={12}>
            <Field name={customAttribute.name} />
          </Grid>
        ))
      ) : (
        <CircularProgress />
      )}
    </>
  )
})
